import { CommonTouchBase, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { positionByPanningVertical } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';

export const SingleTouchVerticalMove: CommonTouchBase = {
  type: 'CommonTouch',
  touchCount: 1,
  key: 'SingleTouchVerticalMove',
  name: 'SingleTouchVerticalMove',
  option: {
    mouseButton: 'left',
    mouseKeyCode: 'none',
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  onMousedown(_camera, _touchData, _canvasProps) {},
  onMousemove(camera: ZEDCamera, touchData: TouchData, _canvasProps: InputCanvasProps) {
    positionByPanningVertical(camera, touchData.movement);
  },
  onMouseup(_camera, _touchData, _canvasProps) {},
  onTouchStart(_camera, _touchData, _canvasProps) {},
  onTouchMoved(camera, touchData, _canvasProps) {
    positionByPanningVertical(camera, touchData[0]!.movement);
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {},
};
